import createTempId from './createTempId'
import isEmpty from './isEmpty'

function getHpBucketForLocationName(locationName) {
  const normalizedName = String(locationName || '')
    .trim()
    .toLowerCase()

  if (normalizedName === 'head') return 'head'
  if (normalizedName === 'chest') return 'chest'
  if (normalizedName === 'abdomen') return 'abdomen'
  if (normalizedName.includes('arm')) return 'arms'
  if (normalizedName.includes('leg')) return 'legs'

  return null
}
//---------------------------------------------------------------------
// convert race armour locations items (to character armour_locations)
//---------------------------------------------------------------------
export default function convertRaceArmourLocations(race_als, locationHPs = {}) {
  console.log('----------------------------------')
  console.log('IN convertRaceArmourLocations')

  if (isEmpty(race_als)) {
    return null
  }

  let als = race_als.map((s) => {
    console.log('convertRaceArmourLocations s = ', s)

    // set init values (as not equipped at this point)
    const armour_count = 0
    const dex_pen = 0
    const highest_layer = 0
    const highest_ap = 0
    const equipped_armour = []

    // set values from static race worn armour location
    const armour_location = s.id ?? null
    const armour_location_name = s.name ?? null
    const seq = s.seq ?? 0
    const half_location = s.locations[0]?.half_location ?? false
    const hpBucket = getHpBucketForLocationName(armour_location_name)
    const hpTotal = hpBucket ? Number(locationHPs?.[hpBucket]) || 0 : 0

    // temp id (wont be saved as character armour_locations auto-created on character creation)
    const id = createTempId()

    return {
      armour_count: armour_count,
      dex_pen: dex_pen,
      highest_layer: highest_layer,
      highest_ap: highest_ap,
      hp_tot: hpTotal,
      hp_cur: hpTotal,
      equipped_armour: equipped_armour,
      armour_location: armour_location,
      armour_location_name: armour_location_name,
      half_location: half_location,
      seq: seq,
      id: id,
    }
  })
  return als
}
